new Vue({
  delimiters: ['[[', ']]'], // change because vue and django using the same args 
  el: '#app_header',
  data: {
    header: {
      Position: 'fixed',
      useFirst: true, // first headerBar

      myaccount_options: 'dropdown', // 'none' = no dropdowns, 'dropdown' = hover and dropdown menu;

      isNavUp: true,
      isNavMin: false,
      lastScrollTop: 0,

      menuMobile: false,
    },
    searchOpened: false,
    cartOpened: false,
    view_origin_home: (view_origin == 'home') ? true : false
  },
  created() {
    window.addEventListener("resize", this.screenHandler);
  },
  destroyed() {
    window.removeEventListener("resize", this.screenHandler);
  },
  methods: {
    screenHandler() {
      this.mobile = (window.innerWidth > 991) ? false : true;
    },

    addPaddingHeader() {
      const headerTransparent = document.querySelector('.nav-up');
      const header = document.querySelector('header#app_header');
      const mainTag = document.querySelector('main[role="main"]');
      const mainDiv = document.querySelector('.main-content');

      if (!header) return;

      let headerHeight = header.clientHeight;

      if (headerTransparent) {
        if (view_origin != "home") {
          if (mainTag) {
            mainTag.style.paddingTop = `${headerHeight}px`;
          } else if (mainDiv) {
            mainDiv.style.paddingTop = `${headerHeight}px`;
          }
        }
      } else {
        if (mainTag) {
          mainTag.style.paddingTop = `${headerHeight}px`;
        } else if (mainDiv) {
          mainDiv.style.paddingTop = `${headerHeight}px`;
        }
      }
    },

    runSpeechRecognition() {
      var isChromium = window.chrome;
      var winNav = window.navigator;
      var vendorName = winNav.vendor;
      var isOpera = typeof window.opr !== "undefined";
      var isIEedge = winNav.userAgent.indexOf("Edge") > -1;
      var isIOSChrome = winNav.userAgent.match("CriOS");

      if (isChromium !== null && typeof isChromium !== "undefined" && vendorName === "Google Inc." && isOpera === false && isIEedge === false) {
        let output = document.querySelector(".output-search");
        let action = document.querySelector(".microphone");
        let inputMic = document.querySelector(".search__text");

        var SpeechRecognition = SpeechRecognition || webkitSpeechRecognition;

        var recognition = new SpeechRecognition();
        recognition.continuous = false;
        recognition.lang = 'pt-BR';


        recognition.onstart = function () {
          if (!output.classList.contains("hide")) {
            output.classList.toggle("hide");
          }

          action.classList.toggle('active');
        };

        recognition.onspeechend = function () {

          action.classList.toggle('active');
          recognition.stop();
        }

        recognition.onresult = function (event) {
          var transcript = event.results[0][0].transcript;
          var confidence = event.results[0][0].confidence * 100;

          if (confidence < 50) {
            inputMic.classList.toggle('not-understand')
            output.classList.toggle("hide");
            inputMic.value = "Desculpe não entendi muito bem.";
          } else {
            inputMic.value = transcript
            document.querySelector('.button-busca').click()
          };

        };

        // start recognition
        recognition.start();
      } else return document.querySelector(".microphone-search").remove();
    },

    handleScroll() {
      const st = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      const scrollDifference = st - this.lastScrollTop;
      const customMobile = document.getElementById('custom-mobile-nav');
      const headerThird = document.getElementById('header-third');
      const quickMenu = document.getElementById('quick-menu-id');
      const whatsappWidget = document.getElementById('widget-whatsapp');

      if (st > this.lastScrollTop)
        this.header.isNavUp = false;
      else {
        if (st === 0)
          this.header.isNavUp = true;
      }

      if (st >= 90 && scrollDifference > 0) {
        this.header.isNavDown = false;
        this.header.isNavMin = true;

        if (customMobile)
          customMobile.classList.add('hide');

        if (headerThird)
          headerThird.classList.add('hide');

        if (quickMenu) {
          quickMenu.classList.add('hide');
          whatsappWidget.style.bottom = '';
        }

      } else {
        this.header.isNavDown = true;
        this.header.isNavMin = false;
        this.header.isNavMenuHide = false;

        if (customMobile)
          customMobile.classList.remove('hide');

        if (headerThird)
          headerThird.classList.remove('hide');

        if (quickMenu) {
          quickMenu.classList.remove('hide');
          whatsappWidget.style.bottom = '79px';
        }
      }

      this.lastScrollTop = st;
    },
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    this.addPaddingHeader();
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  watch: {
    cartOpened(newValue) {
      if (newValue) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.removeProperty('overflow');
      }
    }
  }
})

/* Mobile Wrapper */
const mobileNavLinks = document.querySelectorAll('.mobile-nav__link.ewrap');

mobileNavLinks.forEach(link => {
  link.addEventListener('click', function (event) {
    event.preventDefault();
    this.classList.toggle('active');
    const wrapper = this.nextElementSibling;
    if (wrapper && wrapper.tagName === 'UL') {
      wrapper.classList.toggle('active');
    }
  });
});

var cart_preview_triggers = $('.header__second--tools-cart, .cart-preview-header__close, .cart-preview--overlay, .cart-preview .btn-continue');

cart_preview_triggers.on("click", function (e) {
  $('.header__second--tools-cart-preview').toggleClass('active');
  document.body.classList.toggle('no-scroll');
  document.documentElement.classList.toggle('no-scroll');
});

waitForElementToExist('#js-texto-header').then(element => {
  $('#js-texto-header').slick({
    arrows: false,
    infinite: true,
    autoplay: false,
    autoplaySpeed: 3000,
    dots: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 1000,
  });
});

function initSearchFocus() {
  const searchOpen = document.querySelector('.header__second--tools-search-icon');
  const searchTool = document.querySelector('.header__second--tools-search');
  const searchContainer = document.querySelector('.header__search');
  const search = searchContainer && searchContainer.querySelector('.search');
  const searchHeader = search && search.querySelector('.search__header');
  const searchClose = search && search.querySelector('.search__close');
  const searchText = document.querySelector('.search__text');

  if (!searchOpen || !searchTool || !searchContainer || !search || !searchHeader || !searchClose || !searchText) return;

  function closeSearch() {
    searchTool.classList.remove('open');
    searchContainer.classList.remove('active');
    search.classList.remove('active');
    searchHeader.classList.remove('active');
  }

  searchOpen.addEventListener('click', function (event) {
    event.preventDefault();

    if (searchContainer.classList.contains('active')) {
      closeSearch();
      return;
    }

    searchTool.classList.add('open');
    searchContainer.classList.add('active');
    search.classList.add('active');
    searchHeader.classList.add('active');
    searchText.focus();

    setTimeout(function () {
      searchText.focus();
    }, 100);
  });

  searchClose.addEventListener('click', function () {
    closeSearch();
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSearchFocus);
} else {
  initSearchFocus();
}
